export const css = {
    root: '-ltUYfRD',
    content: 'ETkjW96-',
    loading: 'dTmOCTN0',
    promote: 'E3gRbGrP',
    disabledPromote: 'aapeI7KM',
    domain: 'K2Voidg-',
    title: 'RXEEFZ0O',
    subtitle: 'OdVPmgz7',
    actions: 'JsCYedrr',
    indicator: 'ptNLrkd-',
    ' _key': 'card/tgf'
};
export default css;
